import React from 'react';
import { Link } from 'react-router-dom';

import ReleaseList from '../../components/ReleaseList';
import { slugify } from '../../helpers/view';
import { seriesById } from '../../actions/series';
import { releasesBySeries } from '../../actions/release';
import { seriesReleaseList as seriesReleaseListSelector } from '../../selectors';

import c from './Series.less';

function Series(props) {
  return (
    <ReleaseList
      title="Mp3Caprice - {category} Series"
      description="Music releases by {category} series. Discover, buy and download high quality tunes for reasonable prices."
      pathPrefix="series"
      backToListTitle="All series"
      renderSubItems={(item) => (
        <Link className={c.seriesLink} to={`/series/${slugify(item.name, item.id)}`}>{item.name}</Link>
      )}
      mapState={(store, componentProps) => ({
        currentCategory: store.series.data[componentProps.match.params.id],
        currentCategoryLoading: store.series.loading,
        categoryItems: store.series,
        categoryReleaseList: seriesReleaseListSelector(store, componentProps),
      })}
      mapDispatch={{
        loadCategoryById: seriesById,
        loadReleasesByCategory: releasesBySeries,
      }}
      {...props}
    />
  );
}

export default Series;
